import { configureStore } from '@reduxjs/toolkit'
import modelsComparatorReducer from './modelsComparatorSlice'

export const store = configureStore({
    reducer: {
        modelsComparator: modelsComparatorReducer,
    },
})